import axios from 'axios';
import { useDispatch } from "react-redux"
// import {login} from '../Redux/Reducer/userReducer'
import Login from '../components/Login/Login';
import { setLogin } from '../Redux/Actions';
import {useEffect,useState} from 'react'
import {chatCountState} from '../Redux/Actions'
import { useSelector } from 'react-redux'
const baseUrl = process.env.REACT_APP_BASE_URL;
const loginUrl = process.env.REACT_APP_LOGIN_URL

export async function getChatHistory(data, options) {
  // const chat = useSelector(state => state.chatReducer)
    try {
        const response = await axios.post(baseUrl+'/get_recent_chats?page=1&size=15', data, options);
        return response.data.chat_titles_by_month;
    } catch (error) {
        console.error("Error:", error);
        throw error;
        }
}

export async function getLLmStreamOutput(options) {

  try {
      // const response = await axios.post(baseUrl+'/llm/generate_output', options,formData);

      const response = await fetch(baseUrl+'/v1/llm/generate_output', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json', // Adjust this if needed
            "Authorization": 'Bearer ' + localStorage.token
            // Add any additional headers here
        },
        body: JSON.stringify(options) // Adjust this if needed
    });
    const data = await response.json();
      return data
  } catch (error) {
      console.error("Error:", error);
      throw error;
      }
  
}

// export async function getLLmOutput(options,formData) {

//   try {
//       const response = await axios.post(baseUrl+'/llm/generate_output', options,formData);
//       return response.data
//   } catch (error) {
//       console.error("Error:", error);
//       throw error;
//       }
  
// }

export async function getLLmOutput(formData) {
  try {
    const response = await fetch(baseUrl + '/llm/generate_output', {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + localStorage.token,
        
        'Accept': "text",
        
      },
      body: formData
    });

    if (!response.body) {
      throw new Error('No response body');
    }

    return response.body.getReader();
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}


export async function getChatData(data, options) {
    try {
        const response = await axios.post(baseUrl+'/get_chat', data, options);
        return response;
    } catch (error) {
        console.error("Error:", error);
        throw error;
        }  
}

export async function createChatData(data, options) {
    try {
        const response = await axios.post(baseUrl+'/create_chat', data, options);
        return response;
    } catch (error) {
        console.error("Error:", error);
        throw error;
        }  
}

export async function updateChatData(data, options) {
    try {
        const response = await axios.post(baseUrl+'/update_chat', data, options);
        return response;
    } catch (error) {
        console.error("Error:", error);
        throw error;
        }  
}

export async function renameChatTitle(data, options) {
    try {
        const response = await axios.post(baseUrl+'/rename_title', data, options);
        return response;
    } catch (error) {
        console.error("Error:", error);
        throw error;
        }  
}

export async function deleteChatEndpoint(data, options) {
    try {
        const response = await axios.post(baseUrl+'/delete_chat', data, options);
        return response;
    } catch (error) {
        console.error("Error:", error);
        throw error;
        }  
}

export async function billUpload(data, options) {
  try {
      const response = await axios.post(baseUrl+'/upload-file/', data, options);
      return response;
  } catch (error) {
      console.error("Error:", error);
      throw error;
      }  
}

// export async function getLLmStreamOutput(data,options) {

//     try {
//         const response = await axios.post(baseUrl+'/v2/llm/generate_output', data, options);
//         return response.data
//     } catch (error) {
//         console.error("Error:", error);
//         throw error;
//         }
    
// }

// export async function getLLmStreamOutput(data, options) {
//     const baseUrl = 'http://172.31.0.1:8000'; // Replace with your base URL
//     const url = baseUrl + '/v2/llm/generate_output';
  
//     try {
//       const response = await fetch(url, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json', // Adjust content type if necessary
//           ...options.headers, // Spread custom headers from options
//         },
//         body: JSON.stringify(data), // Ensure data is properly JSON-stringified
//       });
  
//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }
  
//       const reader = response.body.getReader();
  
//       // Using a while loop to continuously read chunks of data
//       while (true) {
//         const { done, value } = await reader.read();
  
//         if (done) {
//           console.log("Streaming complete");
//           break;
//         }
  
//         // Process the chunk (assuming response data is JSON)
//         const chunkData = new TextDecoder().decode(value);
//         console.log('Received chunk:', chunkData);
//         // Optionally, process the chunk further (e.g., append to a buffer)
//         // For example: processDataChunk(value);
//       }
  
//       // Optionally, return a final result after streaming is complete
//       return "Streaming completed";
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       throw error;
//     }
//   }
  

  export async function getLLmOutputStream(data, options) {
    try {
      const apiUrl = baseUrl + '/v2/llm/generate_output';
  
      // Fetch using POST method
      const response = await fetch(apiUrl, {
        method: 'POST',
        ...options,
        body: JSON.stringify(data), // Assuming data is JSON
      });
  
      // Check if the response is OK
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      // Create a ReadableStream from the response body
      const reader = response.body.getReader();
  
      // Read chunks of data as they arrive
      const streamReader = () => {
        reader.read().then(({ done, value }) => {
          if (done) {
            console.log('Stream complete');
            return;
          }
  
          // Process the chunk of data (value), e.g., convert to text
          const data = new TextDecoder().decode(value);
          console.log('Received chunk of data:', data);
  
          // Continue reading
          streamReader();
        }).catch(error => {
          console.error('Error reading stream:', error);
        });
      };
  
      // Start reading the stream
      streamReader();
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  export async function switchRole(role) {	
        
    const data = await axios({
        url: loginUrl,
        method: 'post',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.token
        },
        data: {
        query: `
       mutation switchUserRole($role:UserRole!){
          switchUserRole(role: $role){
            token
            user {
              id
              activeRole
              roles
            }
      	}
      }
        `,
        variables: {
           role:role
            
        }
        },
           
    });
   
    const data1 = data.data.data.switchUserRole
    return data1
    
    }

    export async function createChatFeedback(data, options) {
      try {
          const response = await axios.post(baseUrl+'/create_feedback', data, options);
          console.log("response from create feedback",response)
          return response;
      } catch (error) {
          console.error("Error:", error);
          throw error;
          }  
  }

  
 




